import { fieldRegistry } from '../../../core/fields/registry/FieldRegistry';

import { networkBaseFieldPack } from './packs/base.pack';
import { networkTagsFieldPack } from './packs/tags.pack';
import { networkComputeFieldPack } from './packs/compute.pack';
import { networkSecurityFieldPack } from './packs/security.pack';
import { networkNetworkingFieldPack } from './packs/networking.pack';
import { networkStorageFieldPack } from './packs/storage.pack';
import { networkCostFieldPack } from './packs/cost.pack';
import { networkComplianceFieldPack } from './packs/compliance.pack';
import { networkLifecycleFieldPack } from './packs/lifecycle.pack';

export const NETWORK_FIELD_PACKS = [
  networkBaseFieldPack,
  networkTagsFieldPack,
  networkComputeFieldPack,
  networkSecurityFieldPack,
  networkNetworkingFieldPack,
  networkStorageFieldPack,
  networkCostFieldPack,
  networkComplianceFieldPack,
  networkLifecycleFieldPack,
] as const;

export function registerNetworkFieldPacks(): void {
  // Dependency-ordered: later packs declare earlier ones as dependencies
  // via `dependencies: ['network-base']` so transitive resolution works
  // when the panel calls `fieldRegistry.getFieldsFromPacks(['network-cost'])`
  // and gets cost + tags + base fields back in one go.
  fieldRegistry.registerPack(networkBaseFieldPack);
  fieldRegistry.registerPack(networkTagsFieldPack);
  fieldRegistry.registerPack(networkComputeFieldPack);
  fieldRegistry.registerPack(networkStorageFieldPack);
  fieldRegistry.registerPack(networkNetworkingFieldPack);
  fieldRegistry.registerPack(networkSecurityFieldPack);
  fieldRegistry.registerPack(networkComplianceFieldPack);
  fieldRegistry.registerPack(networkCostFieldPack);
  fieldRegistry.registerPack(networkLifecycleFieldPack);
}

export { networkBaseFieldPack } from './packs/base.pack';
export { networkTagsFieldPack } from './packs/tags.pack';
export { networkComputeFieldPack } from './packs/compute.pack';
export { networkStorageFieldPack } from './packs/storage.pack';
export { networkNetworkingFieldPack } from './packs/networking.pack';
export { networkSecurityFieldPack } from './packs/security.pack';
export { networkComplianceFieldPack } from './packs/compliance.pack';
export { networkCostFieldPack } from './packs/cost.pack';
export { networkLifecycleFieldPack } from './packs/lifecycle.pack';
